import { IContentElement } from "../models";

export interface IContentElementMath extends IContentElement {
    latex: string;
    paragraphStyle: string;
    elementMode?: IEquationBlockMode;
    rawLatex?: string;
    altText?: string;
  }

  export const mathEditInfo = {
    editExcludeFields: [],
    editTextFields: ['latex']
  }

  export enum IEquationBlockMode{
    MATH = 'Math',
    CHEMISTRY = 'Chemistry'
  }